<div class="top-div">
    <div class="center-image"><img src="../assets/images/PUC.png" /></div>
</div>